import { FC } from 'react';
import NextImage from 'src/shared-components/NextImage/NextImage';
import cn from 'classnames';
import Constraints from 'src/shared-components/Constraints/Constraints';
import { FormattedMessage } from 'react-intl';

import trns from './trns';

const partner1 = 'partners/dobrohoDnja.svg';
const partner2 = 'partners/911Pharmacy.svg';
const partner3 = 'partners/ancPharmacy.svg';
const partner4 = 'partners/bamPharmacy.svg';
const partner5 = 'partners/bazhaemoZdorovjaPharmacy.svg';
const partner6 = 'partners/expressPharmacy.svg';
const partner7 = 'partners/kopiykaPharmacy.svg';
const partner8 = 'partners/nyzkiCinyPharmacy.svg';
const partner9 = 'partners/ozchadPharmacy.svg';
const partner10 = 'partners/podorozhnykPharmacy.svg';
const partner11 = 'partners/socialPharmacy.svg';
const partner12 = 'partners/tvoyzRodynaPharmacy.svg';

export const PartnersContainerId = 'partners-container';

const PartnersContainer: FC = () => {
  return (
    <div className={cn('hidden', 'sm:flex sm:py-10')} id={PartnersContainerId}>
      <Constraints className="w-full">
        <div className="flex flex-col w-full items-center justify-center">
          <h2 className="uppercase text-astronautBlue fs-header4-bold text-center">
            <FormattedMessage {...trns.partnersTitle} />
          </h2>
          <div className="flex mt-14 flex-col xl:flex-row">
            <div className="flex flex-row box-border border-b border-silver xl:border-t-0">
              <div className="flex justify-center px-5 py-7 border-r box-border border-silver">
                <NextImage
                  alt="partner"
                  src={partner1}
                  layout="fixed"
                  height={32}
                  width={150}
                />
              </div>
              <div className="flex justify-center px-5 py-7 border-r box-border border-silver">
                <NextImage
                  alt="partner"
                  src={partner12}
                  layout="fixed"
                  height={32}
                  width={150}
                />
              </div>
              <div className="flex justify-center px-5 py-7 border-r-0 xl:border-r box-border border-silver">
                <NextImage
                  alt="partner"
                  src={partner11}
                  layout="fixed"
                  height={32}
                  width={150}
                />
              </div>
            </div>
            <div className="flex flex-row box-border border-b border-silver first:border-t-0">
              <div className="flex justify-center px-5 py-7 border-r box-border border-silver">
                <NextImage
                  alt="partner"
                  src={partner10}
                  layout="fixed"
                  height={32}
                  width={150}
                />
              </div>
              <div className="flex justify-center px-5 py-7 border-r box-border border-silver">
                <NextImage
                  alt="partner"
                  src={partner9}
                  layout="fixed"
                  height={32}
                  width={150}
                />
              </div>
              <div className="flex justify-center px-5 py-7 border-r box-border border-silver last:border-r-0">
                <NextImage
                  alt="partner"
                  src={partner8}
                  layout="fixed"
                  height={32}
                  width={100}
                />
              </div>
            </div>
          </div>
          <div className="flex flex-col xl:flex-row">
            <div className="flex flex-row border-b box-border border-silver xl:border-b-0">
              <div className="flex justify-center px-5 py-7 border-r box-border border-silver">
                <NextImage
                  alt="partner"
                  src={partner7}
                  layout="fixed"
                  height={32}
                  width={150}
                />
              </div>
              <div className="flex justify-center px-5 py-7 border-r box-border border-silver">
                <NextImage
                  alt="partner"
                  src={partner6}
                  layout="fixed"
                  height={32}
                  width={150}
                />
              </div>
              <div className="flex justify-center px-5 py-7 border-r-0 xl:border-r box-border border-silver">
                <NextImage
                  alt="partner"
                  src={partner5}
                  layout="fixed"
                  height={32}
                  width={150}
                />
              </div>
            </div>
            <div className="flex flex-row border-b box-border border-silver last:border-b-0">
              <div className="flex justify-center px-5 py-7 border-r box-border border-silver">
                <NextImage
                  alt="partner"
                  src={partner4}
                  layout="fixed"
                  height={32}
                  width={150}
                />
              </div>
              <div className="flex justify-center px-5 py-7 border-r box-border border-silver">
                <NextImage
                  alt="partner"
                  src={partner3}
                  layout="fixed"
                  height={32}
                  width={150}
                />
              </div>
              <div className="flex justify-center px-5 py-7 border-r box-border border-silver last:border-r-0">
                <NextImage
                  alt="partner"
                  src={partner2}
                  layout="fixed"
                  height={32}
                  width={100}
                />
              </div>
            </div>
          </div>
        </div>
      </Constraints>
    </div>
  );
};

export default PartnersContainer;
